import { Input, Output, EventEmitter, Directive, OnInit, OnDestroy, ElementRef } from "@angular/core";
import { EFProduct } from "pg-lib/models/experience.model";
import { PGUtilities } from "pg-lib/utilities/pg-utilities";

export class TotemWidgetProductsFilter {
    type:string|Array<string>
    category:string|Array<string>
    tags:string|Array<string>
    groups:string|Array<string>
    ids:string|Array<string>
}

@Directive()
export abstract class TotemWidget implements OnInit, OnDestroy {
    abstract size:'md'|'lg';

    @Input() id:string;
    @Input() fullScreen:boolean;
    @Input() fullScreenParams:any;
    @Output() requestFullScreen = new EventEmitter<{ widget?: string, params?: any }>();
    @Output() hideFullScreen = new EventEmitter<null>();

    constructor(public elementRef:ElementRef) {}

    onInactive() {}

    hasInactiveFlip:boolean = false;

    onInactiveFlip() {}

    /** Keyboard activation for clickable widget cards (Enter / Space). */
    onCardKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onCardActivate();
        }
    }

    onCardActivate() {
        this.requestFullScreen.emit();
    }

    ngOnInit() {}

    ngOnDestroy() {}

    applyProductsFilter(products:Array<EFProduct>, filter:TotemWidgetProductsFilter) {
        let _filtered:Array<EFProduct> = []

        if(filter == null) {
            for(let _product of products) {
                _filtered.push(_product)
            }
        }
        else {
            let _filter:{ [prop:string]: Array<string> } = {}
            
            for(let i in filter) {
                let _val = filter[i];

                if(typeof _val == 'string') {
                    if(_val != '') {
                        if(_val.startsWith('[') && _val.endsWith(']')) {
                            try {
                                _filter[i] = JSON.parse(_val);
                            }
                            catch(ex) {
                                console.log(ex)
                                _filter[i] = null;
                            }
                        }
                        else {
                            _filter[i] = PGUtilities.parseCommaSeparatedList(_val)
                        }
                    }
                }
                else {
                    if(_val != null) {
                        _filter[i] = _val;
                    }
                }
            }

            for(let _product of products) {
                if(!_product.isPastProduct()) {
                    let _isIn = true;

                    for(let _prop of ['type','category']) { 
                        if(_filter[_prop] != null) {
                            if(_filter[_prop].indexOf(_product[_prop]) == -1) {
                                _isIn = false;
                                break;
                            }
                        }
                    }

                    if(_filter.tags != null) {
                        for(let _tag of _filter.tags) {
                            if(_product.tags == null || _product.tags.indexOf(_tag.toLowerCase()) == -1) {
                                _isIn = false;
                                break;
                            }
                        }
                    }

                    if(_filter.groups != null) {
                        if(_filter.groups.indexOf(_product.group_id) == -1) {
                            _isIn = false;
                        }
                    }

                    if(_filter.ids != null) {
                        if(_filter.ids.indexOf(_product.id) == -1) {
                            _isIn = false;
                        }
                    }
    
                    if(_isIn) {
                        _filtered.push(_product)
                    }
                }
            }
        }

        _filtered.sort((a, b) => {
            let _aEnd:string = null;
            let _bEnd:string = null;

            if(a.dates != null) {
                for(let _date of a.dates) {
                    if(typeof _date == 'string') {
                        if(_aEnd == null || _date > _aEnd) _aEnd = _date;
                    }
                    else {
                        if(_aEnd == null || _date.end > _aEnd) _aEnd = _date.end;
                    }
                }
            }

            if(b.dates != null) {
                for(let _date of b.dates) {
                    if(typeof _date == 'string') {
                        if(_bEnd == null || _date > _bEnd) _bEnd = _date;
                    }
                    else {
                        if(_bEnd == null || _date.end > _bEnd) _bEnd = _date.end;
                    }
                }
            }

            if(_aEnd != _bEnd) {
                if(_aEnd < _bEnd) return -1;
                else if(_aEnd > _bEnd) return 1;
            }
            else {
                if(_bEnd == null) return -1;
                else if(_aEnd == null) return 1;
                else {
                    if(a.title < b.title) return -1;
                    else if(a.title > b.title) return 1;
                    else return 0;
                }
            }
        })

        return _filtered;
    }
}